import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiBadge, PapiUser } from '@wix/da-types-papi';
import Badge from '@wix/da-shared-react/pkg/Badge';
import AddIcon from '@wix/da-shared-react/pkg/Icons/Add';
import { BiDiv, BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { getProfileOwnerUser } from '../../../../../../selectors/users';
import { Url, CHECKOUT_IDS } from '@wix/da-url';
import { pushBadgeModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import s from '../../BadgeBox/BadgeBox.scss';

export interface Props {
  item: PapiBadge;
  className?: string;
}

const BadgeGiftBox: React.FC<Props> = ({ className, item }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const profileOwnerUser: PapiUser = useSelector(getProfileOwnerUser);
  const newCheckout = useFlag('new_checkout');
  const title = t!('widgets.badgesbox.gift.give', { title: item.title });

  return (
    <div className={classnames(s['root'], s['gift'], className)}>
      <BiDiv
        className={s['flex']}
        onClick={() => {
          if (item.name === 'cake' && newCheckout) {
            window.location.assign(
              `${Url.checkoutLink(CHECKOUT_IDS.CAKE)}&foruserid=${
                profileOwnerUser?.userId
              }`
            );
            return;
          }
          dispatch(
            pushBadgeModal(
              item.name as 'llama' | 'cake',
              (profileOwnerUser && profileOwnerUser.userId) || 0,
              title
            )
          );
        }}
        biData={{
          evid: BiEventType.GIFT_SELECT_CLICK,
          recipientid: profileOwnerUser && profileOwnerUser.useridUuid,
          menu_item_name: `give ${item.name} badge`,
        }}
      >
        <div className={s['badge-info']}>
          <AddIcon className={s['icon']} condensed withPadding />
          <Badge {...item} />
        </div>
        <div className={s['badge-title']}>
          <span className={s['badge-title-text']}>{title}</span>
        </div>
      </BiDiv>
    </div>
  );
};

export default BadgeGiftBox;
